import useSWR from 'swr';
import { EmailTemplate } from '~/types/internal-api';
import internalApiClient from '~/app/shared/util/api/internalApiClient';

export function useEmailTemplates(documentType: number | undefined) {
    const skip = !documentType || documentType < 1;

    const { isLoading, ...rest } = useSWR(
        !skip ? () => `setup/email-templates/${documentType}` : null,
        url => internalApiClient.get<EmailTemplate[]>(url).then(res => res.data),
        { fallbackData: [] }
    );

    return {
        ...rest,
        loading: isLoading,
    };
}
